import React from "react";
import { X, Printer } from "lucide-react";
const COMPANY = {
    name: "PRANEESH INFOTECH",
    address: "Erode, Tamil Nadu, India",
    email: "praneeshinfotech@gmail.com",
    gstin: "",
    phone: "",
};

const SubscriptionInvoice = ({ subscription, member, onClose, }) => {
    if (!subscription) return null;
    const amount = Number(subscription.plan_amount || 0);
    const discount = Number(subscription.discount_amount || 0);
    const gst = Number(subscription.gst_amount || 0);
    const total = Number(
        subscription.total_amount ??
        subscription.paid_amount ??
        amount - discount + gst
    );
    const taxableAmount = Number(
        subscription.taxable_amount ??
        amount - discount
    );
    const gstPercentage = Number(
        subscription.gst_percentage || 0
    );
    const formatMoney = (value) =>
        Number(value || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    const invoiceNumber = subscription.invoice_number || `SUB-${subscription.rfId}`;
    const invoiceDate = subscription.invoice_date || subscription.payment_date || subscription.created_at;
    const dateText = invoiceDate ? new Date(invoiceDate).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric", }) : "-";
    const customerName = member?.name || member?.full_name || member?.member_name || "-";
    const customerMobile = member?.mobile_number || member?.mobile || member?.phone_number || "-";
    const handlePrint = () => {
        window.print();
    };
    return (
        <div className="fixed inset-0 z-[130] flex items-center justify-center bg-black/60 p-3 sm:p-5">
            <div className="flex max-h-[95vh] w-full max-w-3xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl">
                <div className="flex items-center justify-between border-b px-5 py-3 print:hidden">
                    <div>
                        <h3 className="font-bold text-gray-800">GST Invoice</h3>
                        <p className="text-xs text-gray-500">Invoice No: {invoiceNumber}</p>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            onClick={handlePrint}
                            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700">
                            <Printer size={16} />
                            Print Bill
                        </button>
                        <button
                            type="button"
                            onClick={onClose}
                            className="rounded-lg p-2 text-gray-500 hover:bg-gray-100">
                            <X size={20} />
                        </button>
                    </div>
                </div>
                <div id="subscription-invoice" className="overflow-y-auto p-5 sm:p-8 print:overflow-visible print:p-0">
                    <div className="invoice-content mx-auto max-w-2xl text-gray-800">
                        <div className="border-b-2 border-gray-800 pb-5 text-center">
                            <h1 className="text-2xl font-bold uppercase tracking-wide">{COMPANY.name}</h1>
                            <p className="mt-1 text-sm text-gray-600">Technology | Innovation | Growth</p>
                            <p className="mt-2 text-sm text-gray-600">{COMPANY.address}</p>
                            {COMPANY.phone && (
                                <p className="text-sm text-gray-600">Phone: {COMPANY.phone}</p>
                            )}
                            <p className="text-sm text-gray-600">Email: {COMPANY.email}</p>
                            <p className="text-sm text-gray-600">GSTIN: {COMPANY.gstin || "GSTIN not configured"}</p>
                        </div>
                        <div className="flex justify-between gap-4 border-b py-5">
                            <div>
                                <h2 className="text-xl font-bold">TAX INVOICE</h2>
                                <p className="mt-2 text-sm text-gray-600">Invoice No: {invoiceNumber}</p>
                                <p className="text-sm text-gray-600">Invoice Date: {dateText}</p>
                            </div>
                            <div className="text-right">
                                <span className="inline-block rounded-full bg-green-100 px-3 py-1 text-xs font-bold uppercase text-green-700">{subscription.payment_status || "Paid"}</span>
                                <p className="mt-2 text-sm text-gray-600">Subscription ID: #{subscription.rfId}</p>
                            </div>
                        </div>
                        <div className="border-b py-5">
                            <h3 className="mb-2 text-sm font-bold uppercase text-gray-700">Bill To</h3>
                            <p className="font-semibold">{customerName}</p>
                            <p className="text-sm text-gray-600">Mobile: {customerMobile}</p>
                            {member?.email && (
                                <p className="text-sm text-gray-600">Email: {member.email}</p>
                            )}
                            {member?.address && (
                                <p className="text-sm text-gray-600">Address: {member.address}</p>
                            )}
                            {member?.gstin && (
                                <p className="text-sm text-gray-600">Customer GSTIN: {member.gstin}</p>
                            )}
                        </div>
                        <div className="py-5">
                            <table className="w-full border-collapse text-sm">
                                <thead>
                                    <tr className="border-y border-gray-300 bg-gray-50">
                                        <th className="px-3 py-3 text-left">Description</th>
                                        <th className="px-3 py-3 text-center">Duration</th>
                                        <th className="px-3 py-3 text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b border-gray-200">
                                        <td className="px-3 py-4">
                                            <p className="font-semibold">{subscription.plan_name_en || subscription.membership_plan_name || "Membership Subscription"}</p>
                                            <p className="mt-1 text-xs text-gray-500">Membership Service</p>
                                        </td>
                                        <td className="px-3 py-4 text-center">
                                            {subscription.duration_days ? `${subscription.duration_days} days` : "-"}
                                        </td>
                                        <td className="px-3 py-4 text-right font-medium">
                                            ₹{formatMoney(amount)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="ml-auto w-full max-w-sm space-y-2 border-t border-gray-300 pt-4 text-sm">
                            <div className="flex justify-between">
                                <span className="text-gray-600">Plan Amount</span>
                                <span>₹{formatMoney(amount)}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">Discount</span>
                                <span className="text-green-700">- ₹{formatMoney(discount)}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">Taxable Amount</span>
                                <span>₹{formatMoney(taxableAmount)}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">GST ({gstPercentage}%)</span>
                                <span>₹{formatMoney(gst)}</span>
                            </div>
                            <div className="flex justify-between border-t-2 border-gray-800 pt-3 text-base font-bold">
                                <span>Grand Total</span>
                                <span>₹{formatMoney(total)}</span>
                            </div>
                        </div>
                        <div className="mt-6 border-y border-gray-300 py-4">
                            <h3 className="mb-3 text-sm font-bold uppercase text-gray-700">Payment Information</h3>
                            <div className="grid grid-cols-2 gap-3 text-sm">
                                <div>
                                    <p className="text-gray-500">Payment Mode</p>
                                    <p className="font-semibold capitalize">{subscription.payment_mode || "-"}</p>
                                </div>
                                <div>
                                    <p className="text-gray-500">Payment Status</p>
                                    <p className="font-semibold capitalize">{subscription.payment_status || "-"}</p>
                                </div>
                                <div>
                                    <p className="text-gray-500">Transaction Reference</p>
                                    <p className="break-all font-semibold">{subscription.transaction_reference || "-"}</p>
                                </div>
                                <div>
                                    <p className="text-gray-500">Subscription Status</p>
                                    <p className="font-semibold capitalize">{subscription.subscription_status || "-"}</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-8 text-center">
                            <p className="font-semibold">Thank you for your payment!</p>
                            <p className="mt-2 text-xs text-gray-500">This is a computer-generated invoice.</p>
                            <p className="mt-1 text-xs text-gray-500">For queries, contact {COMPANY.email}</p>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
        @media print {
          @page {
            size: A4;
            margin: 15mm;
          }
          body * {
            visibility: hidden !important;
          }
          #subscription-invoice,
          #subscription-invoice * {
            visibility: visible !important;
          }
          #subscription-invoice {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 100% !important;
            max-width: none !important;
            padding: 0 !important;
            overflow: visible !important;
            background: white !important;
          }
          .invoice-content {
            width: 100% !important;
            max-width: none !important;
          }
          body {
            background: white !important;
          }
        }
      `}</style>
        </div>
    );
};

export default SubscriptionInvoice;